// 他参加者の一時情報（プレビュー枠 / ペン途中 / テキストキャレット・選択帯）の
// 「生存時間」を決める定数。
//
// 送信側と受信側の 2 つのレイヤにまたがる不変条件を持つため、1 か所へ集約する。
// useCanvasTransientStore の prune は transforms / penStrokes / textCarets をまとめて掃除するので、
// 呼び出し元が異なる値を渡すとキャレットの実効しきい値まで変わってしまう。
//
// 不変条件:
//   CARET_KEEPALIVE_INTERVAL_MS + 2 * CARET_KEEPALIVE_TICK_MS <= REMOTE_TRANSIENT_STALE_MS
// 左辺は、判定 tick が 1 回遅延・欠落しても実送信間隔が超えない上限である。

/** 受信側が他参加者の一時情報を破棄するまでの無更新時間（ms）。 */
export const REMOTE_TRANSIENT_STALE_MS = 1500;

/** 受信側の掃除タイマーの間隔（ms）。2 つのレイヤが同じ値で prune を呼ぶ。 */
export const REMOTE_TRANSIENT_PRUNE_INTERVAL_MS = 1000;

/** 送信側が、選択が動かないときに同じ内容を送り直す最小間隔（ms）。 */
export const CARET_KEEPALIVE_INTERVAL_MS = 700;

/** 送信側が「送り直す時刻になったか」を判定する tick の周期（ms）。 */
export const CARET_KEEPALIVE_TICK_MS = 350;
